import { useMemo } from 'react';
import { getDefaultBreakpoint } from '../core/util/device/screen';

export default () => useMemo(getDefaultBreakpoint, []);
